import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode'; // Ensure you have jwt-decode installed

const TelegramLoginPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Flag to ensure the logic runs only once
    let handled = false;

    // Function to handle successful login and redirection
    const handleSuccessfulLogin = (token, userId) => {
      if (handled) return; // Prevent double handling
      handled = true;

      try {
        const decoded = jwtDecode(token);
        if (decoded.exp < Date.now() / 1000) {
          throw new Error('Token expired');
        }

        localStorage.setItem('token', token);
        localStorage.setItem('userId', userId);
        navigate('/dashboard');
      } catch (err) {
        console.error('Invalid or expired login token:', err);
        alert('Invalid or expired login token. Please try logging in again.');
        navigate('/login'); // Redirect to a general login or home page
      }
    };

    // --- Scenario 1: Launched via Bot's inline_keyboard (Web App with pre-generated token) ---
    const params = new URLSearchParams(window.location.search);
    const queryToken = params.get('token');
    const queryUserId = params.get('userId');

    if (queryToken && queryUserId) {
      console.log('Attempting login via query parameters (inline_keyboard).');
      handleSuccessfulLogin(queryToken, queryUserId);
      return; // Exit useEffect after handling
    }

    // --- Scenario 2: Launched via Bot's Main Menu Button (Telegram Web App initData) ---
    // This requires telegram-web-app.js to be loaded in public/index.html
    if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.initData) {
      console.log('Attempting login via Telegram Web App initData (Menu Button).');
      const initData = window.Telegram.WebApp.initData;

      // You need to send this initData to a NEW backend endpoint for validation
      // and to receive your application-specific token and userId.
      // Let's assume this new endpoint is '/api/auth/webapp-login'
      fetch('https://adey.lucky.et/api/auth/webapp-login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ initData }),
      })
        .then(response => {
          if (!response.ok) {
            // Check for specific error messages from backend or generic HTTP error
            return response.json().then(errorData => {
              throw new Error(errorData.message || 'Web App login failed due to server error.');
            });
          }
          return response.json();
        })
        .then(data => {
          // data should contain { token, userId } from your new backend endpoint
          if (data.token && data.userId) {
            handleSuccessfulLogin(data.token, data.userId);
          } else {
            throw new Error('Backend did not return token or userId.');
          }
        })
        .catch(err => {
          console.error('Telegram Web App login error:', err);
          alert(`Error logging in via Telegram Web App: ${err.message}. Please try again.`);
          navigate('/login'); // Redirect to a general login or home page
        });

      return; // Exit useEffect after handling
    }

    // --- If neither scenario applies (e.g., direct navigation or invalid entry) ---
    console.log('No valid Telegram login data found. Redirecting to login.');
    alert('No valid Telegram login data found. Please log in through the Telegram bot.');
    navigate('/login');

  }, [navigate]); // navigate is a dependency of useEffect

  return (
    <div className="flex justify-center items-center h-screen text-white bg-gray-900">
      <p className="text-xl font-bold">Processing Telegram Login...</p>
    </div>
  );
};

export default TelegramLoginPage;